<template>
  <section id="lessons" class="sectionSize bg-secondary">
    <div>
      <h2 class="secondaryTitle bg-underline3 bg-100%">{{ t('lessons.title') }}</h2>
    </div>

    <div v-if="loading" class="flex justify-center py-12">
      <div class="w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin" />
    </div>

    <div v-else class="w-full max-w-2xl mx-auto">
      <NuxtLink
        v-for="lesson in lessons"
        :key="lesson._id"
        :to="localePath(`/lesson/${lesson.lesson_order}`)"
        class="flex items-center font-montserrat my-6 no-underline cursor-pointer group"
      >
        <div class="lesson-coin border-2 rounded-full h-12 w-12 flex-shrink-0 flex justify-center items-center mr-4 font-montserrat font-bold text-lg mt-0.5">
          <span style="position:relative;z-index:1">{{ lesson.lesson_order }}</span>
        </div>
        <div class="flex flex-col justify-center">
          <h3 class="font-semibold text-lg md:text-2xl group-hover:underline leading-tight">{{ lesson.lesson_title }}</h3>
          <p class="text-gray-600 leading-relaxed mt-1 text-sm md:text-base">{{ lesson.lesson_summary }}</p>
        </div>
      </NuxtLink>
    </div>
  </section>
</template>

<style scoped>
.lesson-coin {
  position: relative;
  background: #F4F2ED;
  color: #000;
  border-color: #000;
  overflow: hidden;
  transition: color 0.3s ease;
  z-index: 0;
}

.lesson-coin span,
.lesson-coin {
  z-index: 1;
}

.lesson-coin::after {
  content: '';
  position: absolute;
  inset: 50% 50%;
  background: #000;
  border-radius: 50%;
  transition: inset 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.group:hover .lesson-coin {
  color: #fff;
}

.group:hover .lesson-coin::after {
  inset: 0;
}
</style>

<script setup lang="ts">
import type { Lesson } from '~/types/lesson.types'
defineProps<{ lessons: Lesson[], loading?: boolean }>()
const { t } = useI18n()
const localePath = useLocalePath()
</script>
